import { siteMap } from "internal-sitemap";
import React from "react";
import { Redirect } from "react-router";
import { CASI_QUERY_PARAM_NAME } from "utilities/hooks/domain/chat/use-chat-modal";

const CasiRedirectPage = () => {
    return (
        <Redirect
            to={`${siteMap.dashboards.user}?${CASI_QUERY_PARAM_NAME}=true`}
        />
    );
};

export default CasiRedirectPage;
